<template>
  <section class="orgLabel" id="orgLabel">
    <viewTitle
      class="viewTitle"
      title="组织架构 / 角色管理"
      :showReturn="false"
    />
    <div class="orgLabelDiv">
      <div class="labelTree">
        <el-button
          class="addLabel"
          @click="addLabel"
          size="small"
          type="primary"
          >添加角色</el-button
        >
        <p
          v-for="(item, index) in laBelList"
          :key="index"
          :class="'labelP ' + item.id == tableParam.id ? 'labelPActive' : ''"
          @click="getTagTableList(item.id)"
        >
          <el-tag>{{ item.name }}</el-tag>
          <span>
            <i
              class="el-icon-edit"
              @click="editLabel(item.id)"
              style="margin: 0px 10px;"
            ></i>
            <i
              v-if="Number(item.can_delete) == 1"
              class="el-icon-delete"
              @click="delLabel(item.id)"
            ></i>
          </span>
        </p>
      </div>
      <div class="labelUserTable">
        <!-- 按钮组1 -->
        <section class="controler">
          <div class="ml15" style="width: 100%;">
            <el-input
              class=""
              style="width: 200px !important;"
              clearable
              placeholder="输入关键字搜索"
              suffix-icon="el-icon-search"
              v-model="tableParam.keyword"
              @change="changeKeyword"
            ></el-input>
            <el-button
              class="ml15"
              size="small"
              type="primary"
              @click="refreshData"
              >刷新数据</el-button
            >
          </div>
        </section>
        <section class="main-table">
          <el-table
            v-if="showTable"
            :max-height="tableMaxSize"
            style="width: 100%;"
            show-overflow-tooltip
            :data="tableData"
            header-cell-class-name="table-header-cell"
            header-row-class-name="table-header-row"
            cell-class-name="table-cell"
            :border="true"
          >
            <el-table-column prop="name" label="成员姓名">
              <template slot-scope="scope">
                {{ scope.row.name || "--" }}
              </template>
            </el-table-column>
            <el-table-column prop="account" label="账号">
              <template slot-scope="scope">
                {{ scope.row.account || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="所在部门">
              <template slot-scope="scope">
                {{ scope.row.department_names || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="手机号码">
              <template slot-scope="scope">
                {{ scope.row.phone || "--" }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="成员状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1" class="color5E">已激活</span>
                <span v-else-if="scope.row.status == 2" class="color67"
                  >已禁用</span
                >
                <span v-else-if="scope.row.status == 4" class="color66"
                  >未激活</span
                >
                <span v-else-if="scope.row.status == 5" class="color99"
                  >退出企业</span
                >
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="加入时间">
              <template slot-scope="scope">
                {{ formatTime(scope.row.create_time) }}
              </template>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <pagi
              :page="tableParam.page"
              :pageSize="tableParam.page_size"
              :count="count"
              @pageChange="pageChange"
            ></pagi>
          </div>
        </section>
      </div>
    </div>
    <el-dialog
      :title="
        addLableData.detail && addLableData.detail.id ? '修改角色' : '新增角色'
      "
      :visible.sync="addLableData.dialogVisible"
      width="550px"
      class="addOrEditUser"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="100px">
          <el-form-item
            label="角色名称："
            :rules="[{ required: true, message: '' }]"
          >
            <el-input
              v-model="addLableData.detail.name"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="成员及部门：">
            <div
              v-for="(items, key) in deptListObj.pluginResult.select"
              :key="key"
            >
              <span
                v-for="(item, index) in items"
                style="margin-right: 10px;"
                :key="index"
              >
                <User
                  :item="item"
                  :key="key + index"
                  :type="key"
                  @removeTag="removeTag(key, item.id)"
                />
              </span>
            </div>
            <div @click="initDeptSelect" style="color: #409EFF;">
              请选择成员及部门
            </div>
            <!-- </div> -->
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="addLableData.detail.remark"
              placeholder="请输入备注（限50个字符）"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addLableData.dialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="comfireAddTabee" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- <Dept
      v-if="deptListObj.reCreate"
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      :groupId="'160bf8ad7aa64d668f62432ea04ebfd7'"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    /> -->
    <Dept
      v-if="deptListObj.reCreate"
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />
  </section>
</template>
<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import Dept from "@/components/qyDept/";
// import Dept from "@/components/qyDeptGroup/";
import User from "@/components/qyDept/user";
import confirm from "@/components/elementPlus/packages/confirm";

export default {
  props: {},
  data() {
    return {
      laBelList: [],
      tableParam: {
        id: "",
        page: 1,
        page_size: 20,
        keyword: ""
      },
      tableData: [],
      count: 0,
      addLableData: {
        dialogVisible: false,
        detail: {
          name: "",
          department_ids: [],
          user_ids: [],
          remark: ""
        }
      },
      deptListObj: {
        title: "人员部门选择器",
        reCreate: false,
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      }
    };
  },
  watch: {
    tableParam: {
      handler(n) {
        if (n.toString().length > 0) {
          this.getTablelist();
        }
      },
      deep: true
    },
    "addLableData.dialogVisible": function(n) {
      this.deptListObj.reCreate = n;
      if (!n) {
        this.deptListObj.pluginResult = {
          select: { org: [], group: [], user: [] }
        };
      }
    }
  },
  mixins: [mixinTableLyout],
  components: { viewTitle, pagi, Dept, User },
  async mounted() {},
  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },
    // 重写
    resizeTableHeight() {
      this.tableMaxSize = window.innerHeight - 255;
      this.showTable = true;
    },
    getLabelList() {
      return this.$common.http({
        url: "/api/tag/list_all",
        data: {}
      });
    },
    async getTablelist() {
      let dataObj = await this.$common.http({
        url: "/api/tag/search_user_by_page",
        data: this.tableParam
      });
      this.tableData = dataObj.data.data.items;
      this.count = dataObj.data.data.total;
    },
    changeKeyword() {
      this.tableParam.page = 1;
    },
    refreshData() {
      this.getTablelist();
    },
    pageChange(page) {
      this.tableParam.page = page;
    },
    addLabel() {
      this.addLableData = {
        dialogVisible: true,
        detail: {
          name: "",
          department_ids: [],
          user_ids: [],
          remark: ""
        }
      };
    },
    comfireAddTabee() {
      if (this.addLableData.detail.name.trim() === "") {
        this.$common.pcToastFail("请输入角色名称");
        return false;
      }
      if (this.addLableData.detail.remark.trim().length > 50) {
        this.$common.pcToastFail("备注不能超过50个字");
        return false;
      }
      let url = "/api/tag/create_and_bind";
      if (
        this.addLableData.detail.id &&
        this.addLableData.detail.id.length > 0
      ) {
        url = "/api/tag/update_and_bind";
      }
      this.$common
        .http({
          url,
          data: this.addLableData.detail
        })
        .then(async () => {
          this.addLableData.dialogVisible = false;
          const laBelListRes = await this.getLabelList();
          this.laBelList = laBelListRes.data.data;
          if (this.addLableData.detail.id == this.tableParam.id) {
            this.getTablelist();
          }
        });
    },
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
      let user = [];
      this.deptListObj.pluginResult.select.user &&
        this.deptListObj.pluginResult.select.user.forEach(element => {
          user.push(element.id);
        });
      let org = [];
      this.deptListObj.pluginResult.select.org &&
        this.deptListObj.pluginResult.select.org.forEach(element => {
          org.push(element.id);
        });
      console.log(JSON.stringify(this.deptListObj.pluginResult.select));

      this.addLableData.detail.department_ids = org;
      this.addLableData.detail.user_ids = user;
    },
    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },
    initDeptSelect() {
      this.deptListObj.reCreate = true;
      this.deptListObj.visible = true;
    },
    getLableDetail(id) {
      return this.$common.http({
        url: "/api/tag/detail",
        data: { id }
      });
    },
    async editLabel(id) {
      console.log(id);
      const detailRes = await this.getLableDetail(id);
      const { name, remark, depts, users } = detailRes.data.data;
      let department_ids = [];
      depts.forEach(item => {
        department_ids.push(item.id);
      });
      let user_ids = [];
      users.forEach(item => {
        user_ids.push(item.id);
      });
      this.addLableData = {
        dialogVisible: true,
        detail: {
          id,
          name,
          remark,
          department_ids,
          user_ids
        }
      };
      this.deptListObj.pluginResult.select.org = depts;
      this.deptListObj.pluginResult.select.user = users;
    },
    delLabel(id) {
      confirm({
        confirmAc: () => {
          this.$common
            .http({
              url: "/api/tag/delete",
              data: {
                id
              }
            })
            .then(async () => {
              this.$common.pcToastSuccess("删除角色成功");
              const laBelListRes = await this.getLabelList();
              this.laBelList = laBelListRes.data.data;
            });
        },
        confirmAcClass: "btnConfirmDanger",
        cancelAcClass: "btnCancel"
      });
    },
    removeTag(key, reItem) {
      let delIndex = 0;
      this.deptListObj.pluginResult.select[key].forEach((item, index) => {
        if (reItem == item.id) {
          delIndex = index;
        }
      });
      this.deptListObj.pluginResult.select[key].splice(delIndex, 1);
      this.deptListObjConfirm();
    },
    getTagTableList(id) {
      this.tableParam.page = 1;
      this.tableParam.id = id;
    }
  },
  async created() {
    const laBelListRes = await this.getLabelList();
    this.laBelList = laBelListRes.data.data;
    this.tableParam.id = this.laBelList.length > 0 ? this.laBelList[0].id : "";
  }
};
</script>
<style scoped lang="less">
@import "assets/css/common";
@labelTreeWidth: 250px;
@headWidth: 59px;
.orgLabel {
  width: 100%;
  height: 100%;
  .labelP {
    cursor: pointer;
  }
  .controler {
    padding-top: 16px;
  }
  .ml15 {
    margin-left: 15px;
  }
  .viewTitle {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 16px 0 16px;
    height: 59px;
    border-bottom: 1px solid #e4e4e4;
  }
  .orgLabelDiv {
    display: flex;
    height: calc(100% - @headWidth);
    padding: 0 0 0 16px;
    box-sizing: border-box;
    .labelTree {
      padding-top: 16px;
      width: @labelTreeWidth;
      height: 100%;
      box-sizing: border-box;
      border-right: 1px solid #e4e4e4;
      overflow: auto;
      .addLabel {
        width: calc(100% - 16px);
      }
    }
    .labelUserTable {
      width: calc(100% - @labelTreeWidth);
      height: 100%;
    }
  }
  .main-table {
    padding: 16px;
  }
  .page-wrap {
    padding-top: 10px;
  }
  .el-row {
    padding-bottom: 10px;
  }
  .el-col-5 {
    text-align: right;
  }
  .deptSelectResult {
    box-sizing: border-box;
    min-height: 32px;
    background: #ffffff;
    border: 1px solid #cecece;
    border-radius: 4px;
    padding: 4px 10px;
    > span {
      margin-bottom: 4px;
      margin-right: 4px;
    }
  }
}
</style>
